import { isEmpty, merge } from 'lodash'

class Imageable {

  constructor(image) {
    this.url = ''
    this.size = 0
    this.width = 0
    this.height = 0
    this.date = ''

    if (image) {
      merge(this, image)
    }
  }

  get any() {
    return !isEmpty(this.url)
  }

  remove() {
    this.url = ''
    this.size = 0
    this.width = 0
    this.height = 0
    this.date = ''
  }

}

export default Imageable



// WEBPACK FOOTER //
// ./src/models/imageable.js